import { defineMessages } from 'react-intl';

const WniPlatformMessages = defineMessages({
    OK: {
        id: 'custom.platform.flow.angularhelpers.OK',
        defaultMessage: 'OK'
    },
    wantToSaveAndExit: {
        id: 'custom.platform.flow.angularhelpers.CancelConfirmation.Are you sure you want to Save & Exit?',
        defaultMessage: 'Want to Save & Exit?'
    },
    Cancel: {
        id: 'custom.platform.flow.angularhelpers.Cancel',
        defaultMessage: 'Cancel'
    },
    exit: {
        id: 'custom.platform.flow.angularhelpers.Exit',
        defaultMessage: 'Exit'
    },
    saveAndExit: {
        id: 'custom.platform.flow.angularhelpers.Save & Exit',
        defaultMessage: 'Save & Exit'
    },
    No: {
        id: 'custom.platform.flow.angularhelpers.No',
        defaultMessage: 'No',
    },
    TimeoutTitle: {
        id: 'custom.platform.flow.angularhelpers.Timeout Title',
        defaultMessage: 'Waiting...',
    },
    Timeout: {
        id: 'custom.platform.flow.angularhelpers.Timeout',
        defaultMessage: 'We are still working on the process and this will take some time. Please come back later.',
    },
    quoteTimeout: {
        id: 'custom.platform.flow.angularhelpers.quote Timeout',
        defaultMessage: 'The system is still working to process the quote, please check back later.',
    }
});

export default WniPlatformMessages;

export const messages = WniPlatformMessages;